// extracted by mini-css-extract-plugin
module.exports =  {"quick-question":"MzEB4ig","quickQuestion":"MzEB4ig","drawer":"arGY5Kp"};